import styles from './ScoreGauge.module.css'

interface Props {
  /** Voto da 0 a 10 */
  voto: number
  etichetta?: string
  taglia?: number
}

/**
 * Semicerchio che rappresenta uno score 0-10.
 * Colore variabile: rosso < 5, giallo 5-7, verde > 7.
 */
export function ScoreGauge({ voto, etichetta, taglia = 140 }: Props) {
  const v = Math.max(0, Math.min(10, voto))
  const raggio = taglia / 2 - 14
  const circonferenzaMezzo = Math.PI * raggio
  const offset = circonferenzaMezzo * (1 - v / 10)

  const colore = v < 5 ? 'var(--danger)' : v < 7 ? 'var(--warning)' : 'var(--success)'

  return (
    <div className={styles.wrap} style={{ width: taglia }}>
      <svg
        width={taglia}
        height={taglia / 2 + 8}
        viewBox={`0 0 ${taglia} ${taglia / 2 + 8}`}
      >
        {/* Arco sfondo */}
        <path
          d={arco(taglia / 2, taglia / 2, raggio)}
          fill="none"
          stroke="var(--border)"
          strokeWidth={12}
          strokeLinecap="round"
        />
        {/* Arco riempimento */}
        <path
          d={arco(taglia / 2, taglia / 2, raggio)}
          fill="none"
          stroke={colore}
          strokeWidth={12}
          strokeLinecap="round"
          strokeDasharray={circonferenzaMezzo}
          strokeDashoffset={offset}
        />
      </svg>
      <div className={styles.valore}>{v.toFixed(1)}</div>
      {etichetta && <div className={styles.etichetta}>{etichetta}</div>}
    </div>
  )
}

function arco(cx: number, cy: number, r: number): string {
  return `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`
}
